import { PayloadAction } from '@reduxjs/toolkit';
import { deleteMiembro } from '../../api/miembros/deleteMiembro';
import { GenericState } from '../../types/apiModule';
import { User } from '../../types/users/users';
import createApiModule from '../createApiModule';
import { showSnackBar } from '../snackBar/snackBarSlice';
import { listMiembrosRefresh } from './listMiembrosModule';
import { t } from '../../i18n';
export interface deleteOrganizacionState extends GenericState<unknown> {
  active: boolean;
  data: User[];
  miembro: User | null;
}
const initialState: deleteOrganizacionState = {
  errors: null,
  loading: false,
  data: [],
  active: false,
  miembro: null,
};

const deleteMiembroModule = createApiModule({
  name: 'deleteMiembro',
  initialState,
  apiMethod: deleteMiembro,
  onSuccess: () => [
    showSnackBar({
      severity: 'success',
      message: t('MESSAGE_MIEMBRO_BORRADO'),
    }),
    listMiembrosRefresh(),
  ],
  onError: () => ({
    message: t('StoreMiembrosDeleteMiembroModuleErrorBorrandoElMiembroA'),
  }),
  onValidationError: () => ({
    message: t('StoreMiembrosDeleteMiembroModuleErrorBorrandoElMiembroA'),
  }),
  reducers: {
    show(state, action: PayloadAction<User>) {
      state.active = true;
      state.miembro = action.payload;
    },
    hide(state) {
      state.active = false;
    },
  },
});

export const {
  start: del,
  success: delOk,
  error: delKo,
  hide,
  show,
} = deleteMiembroModule.slice.actions;

export default deleteMiembroModule;
